/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'AXS Bolivia S.A.';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="axs-body">
      <div className="row h-100">
        <div className="col-sm-12 my-auto">
          <Row>
            <Col sm="4"></Col>
            <Col sm="4">
              {
                _validateParams()
                  ? <LoginForm
                    api={api}
                    location={location}
                  />
                  : <RequestLoginErrorMessage
                    onlyMessage={true}
                    message={translate('RequestLoginErrorMessage')}
                  />
              }
            </Col>
            <Col sm="4"></Col>
          </Row>
        </div>
      </div>
    </Container>
  );
}

export default WithLocalize(Login);
